import { FormikProps, useFormik } from "formik";
import { BusinessFormProps } from "../types/business-form";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { RootState } from "store";

const useBusinessScreen = () => {
  const getOrganisationdetails = useSelector(
    (state: RootState) => state.merchantForm.organisationDetails
  ) as any;

  const fullAddressForUdhyam = `${getOrganisationdetails?.unit_flat || ""} ${getOrganisationdetails?.unit_block || ""} ${getOrganisationdetails?.["unit_village/town"] ?? ""}  ${getOrganisationdetails?.unit_road || ""} , ${getOrganisationdetails?.unit_city || ""} , ${getOrganisationdetails?.unit_state || ""} - ${getOrganisationdetails?.unit_pin || ""}`.trim();
  const formik: FormikProps<BusinessFormProps> = useFormik<BusinessFormProps>({
    initialValues: {
      gstNumber: getOrganisationdetails?.gstin || "",
      confirmgstNumber: getOrganisationdetails?.gstin || "",
      merchantType:
        getOrganisationdetails?.business_constitution ||
        getOrganisationdetails?.type_of_organisation ||
        "",
      legalName:
        getOrganisationdetails?.legal_name ||
        getOrganisationdetails?.name_of_enterprise ||
        "",
      registeredAddress:
        getOrganisationdetails?.primary_business_address?.registered_address ||
        fullAddressForUdhyam ||
        "",
      businessNature:
        getOrganisationdetails?.primary_business_address?.business_nature ||
        getOrganisationdetails?.major_activity ||
        "",
      gstType: getOrganisationdetails?.tax_payer_type || "",
      gstStatus: getOrganisationdetails?.current_registration_status || "",
      brandName: getOrganisationdetails?.brandName || "",
      cin: getOrganisationdetails?.cin || "",
      authorisedSignatory: getOrganisationdetails?.authorized_signatory || "",
      udhyamNumber: getOrganisationdetails?.udyam_number || "",
      confirmUdhyamNumber: getOrganisationdetails?.udyam_number || "",
      type_of_enterprise: getOrganisationdetails?.type_of_enterprise || "",
      owner_name: getOrganisationdetails?.owner_name || "",
    },
    validationSchema: Yup.object({
      merchantType: Yup.string().required("Merchant Type is required"),
      legalName: Yup.string().required("Legal Name is required"),
      brandName: Yup.string().required(
        "Brand Name is required, can be same as legal name"
      ),

      gstNumber: Yup.string().matches(
        /^[0-9A-Z]{15}$/,
        "GST number must be exactly 15 alphanumeric characters (e.g., 27ABCDE1234F1Z5)"
      ),

      confirmgstNumber: Yup.string().oneOf(
        [Yup.ref("gstNumber")],
        "GST numbers must match"
      ),

      udhyamNumber: Yup.string().matches(
        /^UDYAM-[A-Z]{2}-[0-9]{2}-\d{7}$/,
        "Udyam number must follow format: UDYAM-XX-00-0000000"
      ),

      confirmUdhyamNumber: Yup.string().oneOf(
        [Yup.ref("udhyamNumber")],
        "Udyam numbers must match"
      ),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log("values", values);
    },
  });
  return { formik };
};

export default useBusinessScreen;
